<template>
  <div>
    <div class="container">
      <div class="top-slider">
        <div class="img" :style="{ backgroundImage: 'url(' + info.imageUrl + ')' }"></div>
        <div class="info">
          <h1>
            <span>#</span>
            {{info.number}}
          </h1>
          <div class="full-info">
            <h3 class="part-title">{{info.name}} {{info.lastName}}</h3>
            <h5>{{info.participantPosition.name}}</h5>
            <div class="row">
              <div>
                <h6>Date of birth</h6>
                <p>{{info.birthDate | moment("DD MMMM YYYY") }}</p>
              </div>
              <div>
                <h6>Weight</h6>
                <p>{{info.weight}} kg</p>
              </div>
              <div>
                <h6>Height</h6>
                <p>{{info.height}} cm</p>
              </div>
              <div>
                <h6>Joined club on</h6>
                <p>{{info.joinedAt | moment("DD MMMM YYYY")}}</p>
              </div>
              <div>
                <h6>Country</h6>
                <p>
                  <span class="country-overlay">
                    <!--<flag :iso="info.country.code" />-->
                  </span>
                  <span class="country">{{info.country.name}}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="season-result" v-if="this.info.participantStats.length != 0">
            <h6>{{seasonResults.season.period}} STATS</h6>
            <ul>
              <li>
                Games played
                <span>{{seasonResults.playedGames}}</span>
              </li>
              <li>
                Minutes played
                <span>{{seasonResults.playedMinutes}}</span>
              </li>
              <li>
                Goals
                <span>{{seasonResults.goals}}</span>
              </li>
              <li>
                Assists
                <span>{{seasonResults.assists}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="slider-overlay small-slider">
        <slick ref="slick" :options="slickOptions" @swipe="handleSwipe">
          <div
            class="content"
            v-for="(player, index) in players"
            :key="player.id"
            @click="goTodetail(player.id)"
          >
            <img :src="player.imageUrl" />
            <div class="text">
              <h4>{{player.name}} {{player.lastName}}</h4>
              <p>
                <span>#{{player.number}}</span>
                {{player.participantPosition.name}}
              </p>
            </div>
          </div>
        </slick>
        <div class="slider-button">
          <div class="prev slick-arrow blue" @click="prev()">
            <svg width="27" height="15" viewBox="0 0 27 15" fill="none">
              <rect
                width="1.98052"
                height="24.6213"
                transform="matrix(-0.00338485 0.999994 -0.999995 -0.00331923 26.4004 6.15967)"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.1844 7.02761L8.8985 1.57421L7.5425 0.137733L0.399348 6.95498L1.75535 8.39145L1.75577 8.39106L7.1801 14.1373L8.60873 12.7738L3.1844 7.02761Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="next slick-arrow blue" @click="next()">
            <svg width="27" height="15" viewBox="0 0 27 15" fill="none">
              <rect
                width="1.98052"
                height="24.6213"
                transform="matrix(-0.00338485 0.999994 -0.999995 -0.00331923 26.4004 6.15967)"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.1844 7.02761L8.8985 1.57421L7.5425 0.137733L0.399348 6.95498L1.75535 8.39145L1.75577 8.39106L7.1801 14.1373L8.60873 12.7738L3.1844 7.02761Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="bio container-small">
        <h2>Biography</h2>
        <div v-html="this.bioMain"></div>
        <div v-html="this.showMoreBio" class="bio-overlay" :class="this.open ? 'open' : false"></div>
        <app-show-more :info="readMore" class="blue" :class="info.class" @click.native="openMore"></app-show-more>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import Show_more from "@/components/shared/Show_more";

import News from "@/components/shared/News";

const url = process.env.VUE_APP_URL;

function parse(str) {
  let offset = 0,
    result = [];

  // Ищем очередной <div>
  while ((offset = str.indexOf("<p>", offset)) !== -1) {
    let closed;

    // Ищем ближайщий закрывающий тэг
    // Если его нет - кидаем ошибку
    if ((closed = str.indexOf("</p>", offset)) === -1)
      throw new Error("Unclosed tag!");

    closed += 6;

    // Вырезаем часть с результатом
    result.push(str.substring(offset, closed));
    // Меняем отступ для нового поиска
    offset = closed;
  }
  return result;
}

export default {
  name: "single-player",
  data() {
    return {
      id: this.$route.params.id,
      playersArr: [],
      info: {
        img: "",
        participantStats: [
          {
            assists: 0,
            goals: 0,
            playedGames: 0,
            playedMinutes: 0,
            season: {
              period: "",
            },
          },
        ],
        participantPosition: {
          name: "",
        },
        country: {
          code: "",
          name: "",
        },
      },
      bioMain: "",
      showMoreBio: "",
      seasonResults: {
        season: {
          period: "",
        },
      },
      readMore: {
        text: "Read MOre",
        class: "line-end",
      },
      open: false,
      slickOptions: {
        slidesToShow: 5,
        slidesToScroll: 1,
        //infinite: false,
        prevArrow: ".prev",
        nextArrow: ".next",
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
    },
  },
  computed: {
    players() {
      return this.$store.getters.players;
    },
    news() {
      return this.$store.getters.news;
    },
    imgSrc() {
      return this.info.imageUrl;
    },
  },
  methods: {
    setPlayers() {
      this.axios
        .get(url + "/participants", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setPlayers", payload);
          this.player();
        });
    },
    setNews() {
      this.axios
        .get(url + "/articles", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("setNews", payload);
        });
    },
    player() {
      const playerId = this.$route.params.id;
      this.$store.getters.players.filter((el, index) => {
        //console.log("player id", playerId);
        if (el.id == playerId) {
          el.index = index;
          return (this.info = el);
        }
      });
    },
    goTodetail(playerId) {
      //console.log(this);
      this.$router.push({
        name: "single-player",
        params: { id: playerId },
      });

      this.player();
    },
    next() {
      this.$refs.slick.next();
      var arr = this.$store.getters.players;
      const playerId = +this.$route.params.id + 1;
      if (playerId <= arr.length) {
        this.$router.push({ name: "single-player", params: { id: playerId } });
        this.player();
      } else {
        this.$router.push({ name: "single-player", params: { id: 1 } });
        this.player();
      }
    },
    prev() {
      this.$refs.slick.prev();
      var arr = this.$store.getters.players;
      const playerId = +this.$route.params.id - 1;
      if (playerId == 0) {
        this.$router.push({
          name: "single-player",
          params: { id: arr.length },
        });
        this.player();
      } else {
        this.$router.push({ name: "single-player", params: { id: playerId } });
        this.player();
      }
    },
    reInit() {
      let currIndex = this.info.id;
      this.$refs.slick.destroy();
      //console.log("curr", currIndex);
      this.$nextTick(() => {
        this.$refs.slick.create();
        this.$refs.slick.goTo(currIndex, true);
      });
    },
    handleSwipe(event, slick, direction) {
      if (direction == "left") {
        this.$refs.slick.next();
        var arr = this.$store.getters.players;
        const playerId = +this.$route.params.id + 1;
        if (playerId <= arr.length) {
          this.$router.push({
            name: "single-player",
            params: { id: playerId },
          });
          this.player();
        } else {
          this.$router.push({ name: "single-player", params: { id: 1 } });
          this.player();
        }
      } else {
        this.$refs.slick.prev();
        var arr = this.$store.getters.players;
        const playerId = +this.$route.params.id - 1;
        if (playerId == 0) {
          this.$router.push({
            name: "single-player",
            params: { id: arr.length },
          });
          this.player();
        } else {
          this.$router.push({
            name: "single-player",
            params: { id: playerId },
          });
          this.player();
        }
      }
    },
    htmlSplit() {
      var arr, start, finish;
      arr = parse(this.info.biography);
      start = arr.slice(0, 1).join("");
      finish = arr.slice(1).join("");

      this.bioMain = start;
      this.showMoreBio = finish;
    },
    seasonTable() {
      if (this.info.participantStats.length != 0) {
        var season = this.info.participantStats;
        season.slice(0, 1).map((el) => {
          this.seasonResults = el;
        });
      }
    },
    openMore() {
      this.open = !this.open;
    },
  },

  mounted() {
    this.setPlayers();
    this.player();
    this.htmlSplit();
    this.seasonTable();
  },
  beforeUpdate() {
    if (this.$refs.slick) {
      this.$refs.slick.destroy();
    }
  },
  updated() {
    let currIndex = this.info.id - 1;
    this.$nextTick(() => {
      this.$refs.slick.create(this.slickOptions);
      this.$refs.slick.goTo(currIndex, true);
    });
    this.htmlSplit();
    this.seasonTable();
  },
  beforeDestroy() {
    let currIndex = this.$refs.slick.currentSlide();
    this.$refs.slick.destroy();
    this.$nextTick(() => {
      this.$refs.slick.create(this.slickOptions);
      this.$refs.slick.goTo(currIndex, true);
    });
  },
  destroy() {},
  components: {
    Slick,
    "app-show-more": Show_more,
    "app-news": News,
  },
};
</script>
<style lang="scss" scoped>
.slider-overlay {
  position: relative;
  //width: calc((100% - 8rem) / 6);
  width: calc(100% - 8rem);
  border: 1px solid #f2f2f2;
  margin-bottom: 6rem;
  @media only screen and (max-width: 599px) {
    width: 100vw;
    .swiper-container,
    .slick-slider {
      overflow: visible;
    }
  }
  .slider-button {
    position: absolute;
    right: -8rem;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    @media only screen and (max-width: 599px) {
      display: none;
    }
  }
  .content {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    align-items: center;
    padding-top: 0.5rem;
    border-right: 1px solid #f2f2f2;
    opacity: 0.5;
    position: relative;
    cursor: pointer;
    img {
      height: 5rem;
    }
    h4 {
      font-size: 1.2rem;
      line-height: 1.2rem;
      font-weight: 500;
      text-transform: capitalize;
      color: #5b5b5b;
      margin-bottom: 1rem;
    }
    p {
      font-size: 1rem;
      font-weight: 300;
      color: #a8a8a8;
      line-height: 1.2rem;
      span {
        font-size: 1.2rem;
        font-weight: 700;
        line-height: 1.2rem;
        color: #5b5b5b;
      }
    }
    &:after {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background: #fbbb00;
      content: "";
      transition: all 0.3s ease-in-out;
    }
  }
  .slick-slide {
    &.slick-current,
    &:hover {
      .content {
        opacity: 1;
        &:after {
          width: 100%;
        }
      }
    }
  }
}
.container {
  padding-top: 13rem;
  @media only screen and (max-width: 1199px) {
    padding-top: 6rem;
  }
  .top-slider {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    max-height: 40rem;
    overflow: hidden;
    margin-bottom: 5rem;
    @media only screen and (max-width: 768px) {
      max-height: 100%;
    }
  }
  .img {
    width: 29%;
    margin-right: 6rem;
    background-size: cover;
    background-position: center;
    @media only screen and (max-width: 1199px) {
      width: 30%;
      margin-right: 3rem;
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
      max-width: 35rem;
      padding-top: 37rem;
      margin: 0 auto 4rem;
      img {
        margin: 0 auto;
        width: 30rem;
      }
    }
  }
  .info {
    width: calc(71% - 6rem);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    //margin-bottom: 5rem;
    padding-top: 1.5rem;
    @media only screen and (max-width: 1199px) {
      width: calc(70% - 3rem);
      padding-top: 2rem;
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
  }
  h1 {
    width: 100%;
    font-size: 8rem;
    font-weight: 700;
    line-height: 0.5;
    margin-bottom: 4rem;
    @media only screen and (max-width: 1499px) {
      font-size: 7rem;
      line-height: 5rem;
      margin-bottom: 3rem;
    }
    @media only screen and (max-width: 1199px) {
      font-size: 5.5rem;
      line-height: 4.5rem;
      margin-bottom: 1.5rem;
    }
    span {
      font-size: 4rem;
      font-weight: 600;
      display: inline-block;
    }
  }
}
.full-info {
  width: calc(65% - 10rem);
  @media only screen and (max-width: 1199px) {
    width: calc(70% - 3rem);
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
  h3.part-title {
    font-size: 3rem;
    line-height: 1.3;
    font-weight: 700;
    text-transform: capitalize;
    margin-bottom: 2rem;
  }
  h5 {
    font-size: 1.4rem;
    line-height: initial;
    font-weight: 700;
    color: #a8a8a8;
    text-transform: uppercase;
  }
  & > div {
    display: flex;
    flex-wrap: wrap;
    & > div {
      width: 10rem;
      min-width: 10rem;
      margin-top: 3.7rem;
      margin-right: 1.5rem;
      &:nth-child(1),
      &:nth-child(4) {
        width: calc((100% - 24.5rem));
      }
      @media only screen and (max-width: 1199px) {
        margin-top: 1.5rem;
        width: calc((100% - 4.5rem) / 3);
        &:nth-child(1),
        &:nth-child(4) {
          width: calc((100% - 4.5rem) / 3);
        }
      }

      @media only screen and (max-width: 599px) {
        width: calc((100% - 3rem) / 2);
        margin-top: 2.5rem;
        &:nth-child(1),
        &:nth-child(4) {
          width: calc((100% - 3rem) / 2);
        }
      }
      h6 {
        font-size: 1.2rem;
        font-weight: 300;
        color: #a8a8a8;
        margin-bottom: 0.7rem;
        text-transform: initial;
      }
      p {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 1.6rem;
        font-weight: 700;
        line-height: initial;
        span.country {
          display: inline-block;
          margin-left: 7px;
        }
      }
    }
  }
}
.season-result {
  width: 35%;
  @media only screen and (max-width: 1199px) {
    width: 30%;
  }
  @media only screen and (max-width: 992px) {
    display: none;
  }
  h6 {
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 2.5rem;
  }
  ul {
    li {
      //padding: 1.5rem 0;
      font-size: 1.3rem;
      line-height: 4.5rem;
      border-bottom: 1px solid #e1e1e1;
      span {
        font-size: 1.4rem;
        line-height: 4.5rem;
        font-weight: 600;
        float: right;
      }
    }
  }
}
.bio {
  margin-bottom: 10rem;
  h2 {
    font-size: 2rem;
    line-height: 1.5;
    color: #363636;
    font-weight: 700;
    margin-bottom: 3.5rem;
    text-transform: capitalize;
  }
  .bio-overlay {
    display: none;
    &.open {
      display: block;
    }
  }
}

.show-more {
  margin-top: 3.5rem;
}

.prev,
.next {
  cursor: pointer;
  &.blue {
    svg {
      path,
      rect {
        fill: #262262;
      }
    }
  }
  &.swiper-button-disabled {
    opacity: 0.5;
  }
}
.next {
  transform: rotate(-180deg);
  &:hover {
    -webkit-transform: translate(5px) rotate(-180deg);
    transform: translate(5px) rotate(-180deg);
  }
}
</style>